import React, { useState } from 'react';
import { Activity, Search, ChefHat, Settings, ArrowLeft } from 'lucide-react';
import TabButton from './components/TabButton';
import Logo from './components/Logo';
import SettingsPage from './components/SettingsPage';
import HomePage from './components/HomePage';
import SearchPage from './components/SearchPage';
import KitchenPage from './components/KitchenPage';
import usePersistentState from './hooks/usePersistentState';
import { PetProvider, usePet } from './context/PetContext';
import { getActiveTab, saveActiveTab } from './utils/storage';

export default function FurLogicApp() {
  return (
    <PetProvider>
      <Shell />
    </PetProvider>
  );
}

function Shell() {
  const [activeTab, setActiveTab] = usePersistentState(
    getActiveTab,
    saveActiveTab,
  );
  const [showSettings, setShowSettings] = useState(false);
  const { profile } = usePet();

  return (
    <div className="max-w-md mx-auto bg-gray-50 h-[100dvh] flex flex-col font-sans text-gray-800 shadow-2xl relative overflow-hidden">
      {/* 頂部導航 */}
      <div className="bg-white px-5 py-4 shadow-sm z-20 flex justify-between items-center sticky top-0">
        {showSettings ? (
          <div className="flex items-center gap-2 w-full">
            <button
              type="button"
              onClick={() => setShowSettings(false)}
              aria-label="返回"
              className="p-1 hover:bg-gray-100 rounded-full"
            >
              <ArrowLeft size={24} className="text-gray-600" />
            </button>
            <h1 className="font-bold text-lg text-gray-800">毛孩檔案設定</h1>
          </div>
        ) : (
          <>
            <div className="flex items-center gap-2">
              <Logo size={36} />
              <h1 className="font-bold text-xl tracking-tight text-gray-800">
                FurLogic
              </h1>
            </div>
            <button
              type="button"
              onClick={() => setShowSettings(true)}
              aria-label="開啟毛孩檔案設定"
              className="flex items-center gap-2 bg-gray-100 pl-3 pr-2 py-1.5 rounded-full hover:bg-gray-200 transition"
            >
              <span className="text-sm font-bold text-gray-700">
                {profile.name}
              </span>
              <Settings size={16} className="text-gray-500" />
            </button>
          </>
        )}
      </div>

      {/* 主要內容區 */}
      <div className="flex-1 overflow-y-auto pb-24 scrollbar-hide">
        {showSettings ? (
          <SettingsPage onSave={() => setShowSettings(false)} />
        ) : (
          <>
            {activeTab === 'home' && <HomePage onNavigate={setActiveTab} />}
            {activeTab === 'search' && <SearchPage />}
            {activeTab === 'kitchen' && <KitchenPage />}
          </>
        )}
      </div>

      {/* 底部導航欄 */}
      {!showSettings && (
        <div className="bg-white border-t border-gray-200 px-6 py-2 flex justify-between items-center absolute bottom-0 w-full z-30 pb-safe">
          <TabButton
            id="home"
            label="健康"
            icon={Activity}
            activeTab={activeTab}
            onClick={setActiveTab}
          />
          <TabButton
            id="search"
            label="查詢"
            icon={Search}
            activeTab={activeTab}
            onClick={setActiveTab}
          />
          <TabButton
            id="kitchen"
            label="配餐"
            icon={ChefHat}
            activeTab={activeTab}
            onClick={setActiveTab}
          />
        </div>
      )}
    </div>
  );
}
